module.exports = __webpack_public_path__ + "img/full7-min.30d29f7d.png";